<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#0EA56E"
      text-color="#FFFFFF"
      active-text-color="#FFFFFF"
    >
      <sidebar-item :routes="menus" :collapse="isCollapse"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<!--      -->
<!--      -->

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import ScrollBar from "@/components/ScrollBar";
import { findPermissions } from "@/api/permission";

export default {
  data() {
    return {
      menus: [],
      addMenu: {
        createTime: "2019-12-13 07:02:18",
        createUser: "system",
        modifyTime: "2019-12-13 07:02:18",
        modifyUser: "system",
        archiveTime: null,
        archiveFlag: null,
        id: 1,
        parentId: 0,
        permName: "首页",
        permValue: "",
        url: "/home",
        icon: "home",
        type: 0,
        status: 0,
        sort: 1,
        hasParent: false,
        hasChildren: true,
        checked: false
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      findPermissions(this.findPermissions).then(response => {
        if (response.code == 0) {
          const data = response.data;
          data.unshift(this.addMenu);
          this.menus = data;
          console.log(this.$store);
          this.$store.commit("SET_MENUS", this.menus);
          console.log(this.menus);
        }
      });
    }
  },
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters(["sidebar"]),

    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue